// src/services/administrativo/FilialLogoService.js
import { deleteData, fetchData, putData } from '../Api';

export const fetchFilialLogo = async (filialId) => {
    if (!filialId) return null;
    const result = await fetchData(`/Filial/${filialId}/logo`);
    return typeof result === 'string' && result.trim() ? result : null;
};

export const updateFilialLogo = async (filialId, logoBase64) => {
    if (!filialId) return null;
    return putData(
        `/Filial/${filialId}/logo`,
        JSON.stringify(logoBase64 || ''),
        { headers: { 'Content-Type': 'application/json' } }
    );
};

export const fetchFilialLogoDelivery = async (filialId) => {
    if (!filialId) return null;
    const result = await fetchData(`/Filial/${filialId}/logo-delivery`);
    return result?.imagemBase64 ? result : null;
};

export const updateFilialLogoDelivery = async (filialId, imagemBase64) => {
    if (!filialId) return null;
    return putData(`/Filial/${filialId}/logo-delivery`, { imagemBase64 });
};

export const deleteFilialLogoDelivery = async (filialId) => {
    if (!filialId) return null;
    return deleteData(`/Filial/${filialId}/logo-delivery`);
};
